import { render, staticRenderFns } from "./AcctTransaction.vue?vue&type=template&id=19250b98&"
import script from "./AcctTransaction.vue?vue&type=script&lang=js&"
export * from "./AcctTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports